import { css } from 'styled-components';

const desktopSize = 992;

const media = {
  desktop: (...args) => css`
    @media only screen and (min-width: ${desktopSize}px) {
      ${css(...args)};
    }
  `,
  mobile: (...args) => css`
    @media only screen and (max-width: ${desktopSize - 1}px) {
      ${css(...args)};
    }
  `,
};

export default media;
